/**
 * 设置页面title
 */

import { useEffect, useRef, useState } from 'react';
import usePageView from './usePageView';

function debounce(func: (...args: any) => any, waitTime = 0) {
  let timeout: NodeJS.Timeout;

  return (...args: any) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      func(...args);
    }, waitTime);
  };
}

const setTitle = debounce((title: string) => {
  const isIPhone = window.navigator.appVersion.match(/iphone|ipad|ipod/gi);

  // ios 需要hack才能修改title
  if (isIPhone) {
    document.title = title;
    const iframe = document.createElement('iframe');

    iframe.style.display = 'none';
    iframe.setAttribute('src', 'about:blank');
    const d = () => {
      setTimeout(() => {
        iframe.removeEventListener('load', d);
        document.body.removeChild(iframe);
      }, 0);
    };

    iframe.addEventListener('load', d);
    document.body.appendChild(iframe);
  } else {
    document.title = title;
  }
}, 50);

/**
 * @deprecated 请使用 `usePageConfig`
 */
export default (title: string) => {
  const prevValueRef = useRef(title);

  usePageView(title);

  useState(() => {
    setTitle(title);
  });

  useEffect(() => {
    if (prevValueRef.current !== title) {
      setTitle(title);
    }
  }, [title, prevValueRef]);
};
